import { sectionGradientStyle } from "@/lib/sectionTheme";

export default function PageHeader({
  icon: Icon,
  title,
  subtitle,
  gradient = "from-indigo-600 via-violet-600 to-fuchsia-600",
  brandGradient = true,
  sectionKey,
  children,
}) {
  let style;
  if (sectionKey) {
    style = sectionGradientStyle(sectionKey, "to bottom right");
  } else if (brandGradient) {
    style = {
      background: "linear-gradient(to bottom right, hsl(var(--header-from)), hsl(var(--header-via)), hsl(var(--header-to)))",
    };
  }

  return (
    <div
      className={`rounded-xl px-5 py-3.5 text-white shadow-md ${!style ? `bg-gradient-to-br ${gradient}` : ""}`}
      style={style}
    >
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          {Icon && (
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/20 backdrop-blur">
              <Icon className="h-4 w-4" strokeWidth={1.5} />
            </div>
          )}
          <div className="min-w-0">
            <h1 className="font-display text-xl font-semibold leading-tight tracking-tight md:text-2xl">{title}</h1>
            {subtitle && <p className="mt-0.5 text-xs leading-snug text-white/80 md:text-sm">{subtitle}</p>}
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}
